import { render, staticRenderFns } from "./HoseCapacityOverview.vue?vue&type=template&id=2873158c&scoped=true"
import script from "./HoseCapacityOverview.vue?vue&type=script&lang=js"
export * from "./HoseCapacityOverview.vue?vue&type=script&lang=js"
import style0 from "./HoseCapacityOverview.vue?vue&type=style&index=0&id=2873158c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2873158c",
  null
  
)

export default component.exports